import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect } from "react";
import "./testimonials.scss";

const testimonials = [
  { 
    name: "Amit Sharma", 
    designation: "E-commerce Entrepreneur", 
    feedback: "Arrow Digital transformed our online presence! Our leads doubled within months.", 
    image: "/img1.jpg" 
  },
  { 
    name: "Priya Malhotra", 
    designation: "Startup Founder", 
    feedback: "Thanks to Arrow Digital, our website traffic and conversions skyrocketed!", 
    image: "/img2.jpg" 
  },
  { 
    name: "Rahul Verma", 
    designation: "Restaurant Owner", 
    feedback: "Their social media management boosted our engagement and brand visibility!", 
    image: "/img3.jpg" 
  },
  { 
    name: "Sneha Kapoor", 
    designation: "Marketing Manager", 
    feedback: "Professional, result-driven, and innovative! They helped us generate high-quality leads.", 
    image: "/img4.jpg" 
  },
  { 
    name: "Rohit Mehta", 
    designation: "SaaS Business Owner", 
    feedback: "Their expertise in Facebook and Google Ads is outstanding! Significant ROI increase.", 
    image: "/img5.jpg" 
  },
  { 
    name: "Vivek Soni", 
    designation: "Real Estate Consultant", 
    feedback: "Lead generation campaigns worked wonders for my business. Highly recommended!", 
    image: "/img6.jpg" 
  },
  { 
    name: "Ananya Bose", 
    designation: "Fashion Brand Owner", 
    feedback: "SEO and content marketing brought organic growth to my store. Impressed!", 
    image: "/img8.jpg" 
  },
 
];


const Testimonials = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 5000); // Change slide every 3 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="testimonials-container">
      <motion.h2 
        className="title"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        Customers Feedback
      </motion.h2>
      <div className="carousel">
        <AnimatePresence>
          {testimonials.slice(current, current + 1).map((testimonial, index) => (
            <motion.div
              className="testimonial-card"
              key={index}
              initial={{ opacity: 0, x: 100 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -100 }}
              transition={{ duration: 0.5 }}
            >
              <img src={testimonial.image} alt={testimonial.name} className="avatar" />
              <p className="feedback">"{testimonial.feedback}"</p>
              <h4 className="name">{testimonial.name}</h4>
              <span className="designation">{testimonial.designation}</span>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default Testimonials;